export default __webpack_public_path__ + "static/media/Background_00275.67331f82.png";